import React from "react";
import classes from "./ProductShimmer.module.scss";

const ShimmerLine = ({ className }) => (
  <div className={`${classes.shimmer_line} ${className || ""}`} />
);

const ProductCardShimmer = () => (
  <div className={classes.product_card}>
    <ShimmerLine className={classes.image} />
    <div className={classes.details}>
      <ShimmerLine className={classes.name} />
      <ShimmerLine className={classes.name_short} />
      <ShimmerLine className={classes.price} />
    </div>
  </div>
);

const ProductShimmer = () => {
  return (
    <div className={classes.product_shimmer}>
      <div className={classes.grid}>
        {[...Array(12)].map((_, i) => (
          <ProductCardShimmer key={i} />
        ))}
      </div>
    </div>
  );
};

export default ProductShimmer;
